<ng-container #salesforceChatHost></ng-container>
<ion-app id="ionApp" [dir]="langDirection || 'ltr'">
  <ion-modal [isOpen]="sessionTimeout.warningVisible$ | async" [backdropDismiss]="false" [keyboardClose]="false" cssClass="session-timeout-modal" aria-labelledby="session-timeout-title">
    <ng-template>
      <ion-content class="session-timeout-content">
        <div class="session-timeout-container">
          <ion-icon *ngIf="selectedTheme == 'light'" class="session-timeout-icon"
            [src]="'assets/icon/sessionExpired.svg'"
          ></ion-icon>
          <ion-icon *ngIf="selectedTheme == 'dark'" class="session-timeout-icon"
            [src]="'assets/icon/sessionExpired-dark.svg'"
          ></ion-icon>
          <ion-text id="session-timeout-title" class="sessionTitle">
            {{'session_about_to_expire' | translate}}
          </ion-text>

          <ion-text class="sessionText">
            {{'session_expiration_message' | translate}}
            <br />
            <strong>
              {{ Math.floor((sessionTimeout.remainingSeconds$ | async) / 60) }}m
              {{ ((sessionTimeout.remainingSeconds$ | async) % 60 | number:'2.0-0') }}s.
            </strong>
          </ion-text>

          <ion-button
            class="session-timeout-button"
            expand="block"
            [disabled]="sessionTimeout.refreshing$ | async"
            (click)="sessionTimeout.refreshSession()"
            aria-label="Stay Logged In"
          >
          <ion-text class="sessionButton">{{'general_extendingSession' | translate}}</ion-text>
          </ion-button>

        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
  <div class="registration-navigation-loader" *ngIf="registrationNavigationLoading" role="status" aria-label="Loading Accounts">
    <ion-spinner name="crescent"></ion-spinner>
  </div>
  <ng-container *ngIf="showPop">
    <div class="overlay"></div>
    <ion-card  class="cardVerifyEmail">
      <ion-icon id="veIconClose" (click) = "closerModal()" class="iconVerifyEmail"  name="close-outline"></ion-icon>
      <img class="imgVerifyEmail" src="/assets/images/VE-img.svg"/>
      <br><br>
      <ion-label class="labelVerifyEmail" >{{'Email sent.' | translate}}<br>{{'Please check your inbox.' | translate}}</ion-label>
      <ion-button id="veButton" class="buttonVerifyEmail" (click)="closerModal()" >
        <ion-text >{{'general_okButton' | translate}}</ion-text>
      </ion-button>
    </ion-card>
  </ng-container>
  
  <ion-split-pane [when]="!mobileMenu" contentId="main-content" >
    <ion-menu [ngClass]="{'menuClosed': !menuOpen}" disabled="mobileMenu" [@toggleMenu]="menuOpen ? true : false" contentId="main-content" menuId="mainMenu" type="overlay" side="start">
      <img class="menu-logo" (click)="navigateToPage(PageURL.ACCOUNTS)" [ngStyle]="{'width': menuOpen ? '50px' : '40px', 'margin-inline-start': menuOpen ? '20px' : '15px'}" [src]="menuLogoSrc" alt="logo">
      <div class="toggle-btn" [ngClass]="{'closedButton': !menuOpen}">
        <ion-button fill="clear" (click)="toggleMenu()"><ion-icon name="{{menuArrow}}"></ion-icon></ion-button>  
      </div>
      <ion-content>
        <div [ngClass]="!menuOpen ? 'menu-container-closed' : ''">
          <ion-list id="menu-list">
            <div class="menu-wrapper">
  
              <ng-container *ngFor="let p of appPages; let i = index; trackBy: trackByPage">
  
                <ng-container *ngIf="!p.children">
                  <ion-menu-toggle auto-hide="false" *ngIf="p.url" (click) ="openPopup(p)" [id]="p.htmlId">
                    <ion-item [id]="'menuItem' + p.bottomTitle" (click)="controlPages(i)" routerDirection="root" [routerLink]="[p.url]" routerLinkActive="selected" #rla="routerLinkActive" lines="none" detail="false"
                    [matTooltip]="!menuOpen ? (p.title | translate) : ''">
                      <!-- <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon> -->
                      <ion-icon *ngIf="!rla.isActive && selectedTheme == 'light'" slot="start" [src]="'assets/icon/menu/' + p.icon_inactive"></ion-icon>
                      <ion-icon *ngIf="!rla.isActive && selectedTheme == 'dark'"  slot="start" [src]="'assets/icon/menu/' + p.icon_inactive_dark"></ion-icon>
                      <ion-icon *ngIf="rla.isActive" slot="start" class="wb-filter-mycustom" [src]="'assets/icon/menu/' + p.icon_active"></ion-icon>
                      <ion-label *ngIf="menuOpen" >{{ p.title | translate}}</ion-label>
                    </ion-item>
                  </ion-menu-toggle>
                </ng-container>
  
                <ng-container *ngIf="p.children?.length > 0">
                  <ion-menu-toggle auto-hide="false">
                  <ion-item  [id]="'menuItem' + p.bottomTitle" class="sub-menu-parent-item" [ngClass]="{'active-parent': activeParent == i}" (click)="controlPages(i,'parent'); onPageClicked(p)" lines="none" detail="false"
                    [matTooltip]="!menuOpen ? (p.title | translate) : ''">
                    <!-- <ion-icon slot="start" [ios]="p.icon + '-outline'" [md]="p.icon + '-sharp'"></ion-icon> -->
                    <ion-icon *ngIf="!mobileMenu && activeParent != i && selectedTheme == 'light'" slot="start" [src]="'assets/icon/menu/' + p.icon_inactive"></ion-icon>
                    <ion-icon *ngIf="!mobileMenu && activeParent != i && selectedTheme == 'dark'" slot="start" [src]="'assets/icon/menu/' + p.icon_inactive_dark"></ion-icon>
                    <ion-icon *ngIf="!mobileMenu && activeParent == i" class="wb-filter-mycustom" slot="start" [src]="'assets/icon/menu/' + p.icon_active"></ion-icon>
                    <ion-label *ngIf="menuOpen" >{{ p.title | translate }}</ion-label>
                    <ion-icon class="menuOpenIcon" *ngIf="!mobileMenu && p.open && selectedTheme == 'light'" slot="end" src="assets/icon/wb-icons/wb-chevron-up.svg"></ion-icon>
                    <ion-icon class="menuOpenIcon" *ngIf="!mobileMenu && !p.open && selectedTheme == 'light'" slot="end" src="assets/icon/wb-icons/wb-chevron-down.svg"></ion-icon>
                    <ion-icon class="menuOpenIcon" *ngIf="!mobileMenu && p.open && selectedTheme == 'dark'" slot="end" src="assets/icon/wb-icons/dark-wb-chevron-up.svg"></ion-icon>
                    <ion-icon class="menuOpenIcon" *ngIf="!mobileMenu && !p.open && selectedTheme == 'dark'" slot="end" src="assets/icon/wb-icons/dark-wb-chevron-down.svg"></ion-icon>
                  </ion-item>
                  </ion-menu-toggle>
                  
                    <ion-list class="sub-menu-list" *ngIf="menuOpen" [ngClass]="{'sub-menu-list-closed': !menuOpen, 'sub-menu-list-open': !mobileMenu && p.open}" lines="none">
                    <ion-menu-toggle *ngFor="let sub of p.children; let j = index; trackBy: trackByChild" auto-hide="false">
                      <ion-item (click)="openPopup(p);controlPages(i,'child',j)" [hidden]="!mobileMenu && !p.open" routerDirection="root" [routerLink]="[sub.url]" routerLinkActive="selected" #rlsub="routerLinkActive" detail="false"
                      [matTooltip]="!menuOpen ? (sub.title | translate) : ''">
                        <ion-icon *ngIf="!rlsub.isActive && selectedTheme == 'light'" slot="start" [src]="'assets/icon/menu/' + sub.icon_inactive"></ion-icon>
                        <ion-icon *ngIf="!rlsub.isActive && selectedTheme == 'dark'" slot="start" [src]="'assets/icon/menu/' + sub.icon_inactive_dark"></ion-icon>
                        <ion-icon *ngIf="rlsub.isActive" class="wb-filter-mycustom" slot="start" [src]="'assets/icon/menu/' + sub.icon_active"></ion-icon>
                        <ion-label >{{ sub.title | translate}}</ion-label> 
                      </ion-item>
                    </ion-menu-toggle>
                  </ion-list>
                </ng-container> 
                
              </ng-container>
              
            </div>
          </ion-list>
          <ion-list id="menu-list-footer">
            <div class="menu-wrapper">
              <ng-container *ngFor="let p of appBottomPages; let k = index; trackBy: trackByPage">
                <a [href]="p.url" class="redirect-link">
                  <ion-item (click)="selectedIndexFooter = k; selectedIndexSub = -1; selectedIndex = -1; redirect(p.url)" routerDirection="root" lines="none" detail="false" [class.selected]="selectedIndexFooter == k" [ngStyle]="{'font-size': fontSize }">
                    <ion-icon *ngIf="selectedIndexFooter != k && selectedTheme == 'light'" slot="start" [src]="'assets/icon/menu/' + p.icon_inactive"></ion-icon>
                    <ion-icon *ngIf="selectedIndexFooter != k && selectedTheme == 'dark'" slot="start" [src]="'assets/icon/menu/' + p.icon_inactive_dark"></ion-icon>
                    <ion-icon *ngIf="selectedIndexFooter == k" slot="start" class="wb-filter-mycustom" [src]="'assets/icon/menu/' + p.icon_active"></ion-icon>
                    <ion-label *ngIf="menuOpen" >{{ p.title | translate }}</ion-label>
                  </ion-item>
                </a>
              </ng-container>
            </div>
          </ion-list>
        </div>
      </ion-content>
    </ion-menu>
    <div id="main-content">
      <div *ngIf="!mobileMenu && !menuOpen && submenuOpen" [ngClass]="langDirection === 'ltr'?'submenu-side-left':'submenu-side-right'">
        <ion-row class="title-container">
          <ion-label>{{activePage.title | translate}}</ion-label>
          <ion-button fill="clear" size="lg" (click)="onPageClicked(null)"><ion-icon name="close-outline"></ion-icon></ion-button>
        </ion-row>
        
        <ion-row class="submenu-container">
          <ion-menu-toggle class="submenu-toggle" *ngFor="let sub of activePage.children; let j = index" auto-hide="false">
            <ion-item (click)="selectedIndexSub = j + sub.id; selectedIndex = -1; selectedIndexFooter = -1; selectedSubMenu = sub" [hidden]="!activePage.open" routerDirection="root" [routerLink]="[sub.url]" routerLinkActive="selected" #rlsub="routerLinkActive" detail="false" lines="none">
              <ion-icon *ngIf="!rlsub.isActive && selectedTheme == 'light'" slot="start" [src]="'assets/icon/menu/' + sub.icon_inactive"></ion-icon>
              <ion-icon *ngIf="!rlsub.isActive && selectedTheme == 'dark'" slot="start" [src]="'assets/icon/menu/' + sub.icon_inactive_dark"></ion-icon>
              <ion-icon *ngIf="rlsub.isActive" slot="start" class="wb-filter-mycustom" [src]="'assets/icon/menu/' + sub.icon_active"></ion-icon>
              <ion-label >{{ sub.title | translate}}</ion-label> 
            </ion-item>
          </ion-menu-toggle>
        </ion-row>
      </div>
      <ion-router-outlet></ion-router-outlet>
      <ion-modal #modalBottom [initialBreakpoint]="0.5" [breakpoints]="[0,0.5,0.75,1]">
        <ng-template>
          <app-bottom-navigation-modal [page]="activePage" [selectedTheme]="selectedTheme" [selectedSubMenu]="selectedSubMenu" (selectedPage)="subMenuSelected($event)"></app-bottom-navigation-modal>
        </ng-template>
      </ion-modal>
      <app-bottom-navigation *ngIf="mobileMenu" [userInfo]="userInfo" [activeUrl]="activeUrl" (activePage)="presentBottomModal($event)"></app-bottom-navigation>
    </div>
    
  </ion-split-pane>
  

  <!-- <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button style="width: 40px; height: 40px;">
      <ion-icon style="font-size: 20px;" name="build-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top">
      <ion-fab-button color="dark" (click)="switchTheme('dark')" >{{'dark'|translate}}</ion-fab-button>
      <ion-fab-button color="light" (click)="switchTheme('light')" >{{'light'|translate}}</ion-fab-button>
      <ion-fab-button color="medium" (click)="switchLang('en')">eng</ion-fab-button>
      <ion-fab-button color="medium" (click)="switchLang('ar')">ar</ion-fab-button>
    </ion-fab-list>
  </ion-fab> -->
</ion-app>
